<div class="container mt-3">
    <h1 class="text-center articulo-title text-large">Error 404</h1>
</div>
<h1 class="text-center">Error!!! no se puede encontrar la página solicitada</h1>